import { UppKonvaShape } from '../upp-konva-shape';
import type { UppKonvaTableShapeOptions } from '../upp-konva-options';

/** Table shape. */
export class UppKonvaTableShape extends UppKonvaShape {
    // 1. Type contract
    readonly kind = 'TABLE' as const;

    // 2. Lifecycle
    constructor(opts: UppKonvaTableShapeOptions) {
        const { shape, chairs, ...rest } = opts;
        super({
            ...rest,
            data: { shape, chairs },
        });
    }
}
